import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';

// Whole-app final-check finding: nothing in this app ever caught a render
// error — any uncaught throw (a bad toast payload, or anything else)
// unmounted the entire tree to a blank white screen with no way back
// short of a manual reload, over what's often a one-off glitch rather
// than a broken app. A financial tool a non-technical user relies on
// needs a floor under that.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#151210', color: '#e8e2d8', fontFamily: 'sans-serif', padding: 24, textAlign: 'center' }}>
          <div>
            <div style={{ fontSize: 20, marginBottom: 12 }}>Something went wrong.</div>
            <div style={{ opacity: 0.7, marginBottom: 20 }}>Your data is safe — this screen just needs a reload.</div>
            <button onClick={() => window.location.reload()} style={{ background: '#c9a84c', color: '#151210', border: 'none', borderRadius: 999, padding: '10px 24px', fontSize: 14, cursor: 'pointer' }}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

// Restore theme
const savedTheme = localStorage.getItem('theme') || 'dark';
document.documentElement.classList.toggle('light', savedTheme === 'light');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <App />
      <Toaster theme={savedTheme === 'light' ? 'light' : 'dark'} position="top-right" richColors />
    </BrowserRouter>
  </ErrorBoundary>
);
